/**
 * 声音控制终端
 */
var SoundController = /** @class */ (function () {
    function SoundController(opts) {
        var _a;
        /**
         * 一些回调监听
         */
        this._listener = [];
        this._isEnable = opts.initEnable;
        this.soundList = (_a = opts.sounds) !== null && _a !== void 0 ? _a : [];
        this.broadcast();
    }
    SoundController.prototype.broadcast = function () {
        var _this = this;
        this.soundList.forEach(function (s) {
            if (_this._isEnable) {
                s.enable();
            }
            else {
                s.disable();
            }
        });
        this._listener.forEach(function (l) { return l(_this._isEnable); });
    };
    /**
     * 增加管理的音频
     */
    SoundController.prototype.addSound = function (sound) {
        sound.isEnable = this._isEnable;
        this.soundList.push(sound);
    };
    Object.defineProperty(SoundController.prototype, "isEnable", {
        /**
         * 声音是否开启
         */
        get: function () {
            return this._isEnable;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 开启声音
     */
    SoundController.prototype.enable = function () {
        this._isEnable = true;
        this.broadcast();
    };
    /**
     * 关闭声音
     */
    SoundController.prototype.disable = function () {
        this._isEnable = false;
        this.broadcast();
    };
    /**
     * 当声音变化时候的回调
     */
    SoundController.prototype.onEnableStatusChange = function (fn) {
        var _this = this;
        this._listener.push(fn);
        return function () {
            _this._listener = _this._listener.filter(function (f) { return f !== fn; });
        };
    };
    return SoundController;
}());
export { SoundController };
